'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@algoacademy/design-system/web/actions/Link';
import { P2 } from '@algoacademy/design-system/web/typography/Paragraph/P2';
import type { ReactNode } from 'react';
import { IconOnTheLeftWithContentLayout } from '@/app/(marketing-site)/mentoring/_layouts/IconOnTheLeftWithContentLayout';
import { regulaminSectionHref } from '@/app/(marketing-site)/regulamin/_constants/section-hrefs';
type BenefitItem = {
  lead: string;
  rest: ReactNode;
};
export const BENEFITS: BenefitItem[] = [{
  lead: 'Samodzielny wybór mentora',
  rest: 'Przeglądasz profile i decydujesz z kim chcesz pracować, bez losowego przypisywania.'
}, {
  lead: 'Wsparcie mentora przez komunikator',
  rest: 'Masz stały kontakt z mentorem - piszesz, gdy potrzebujesz wsparcia, i dostajesz wskazówki oraz feedback na bieżąco.'
}, {
  lead: 'Zajęcia grupowe z ekspertami',
  rest: 'Uczysz się od najlepszych w danej dziedzinie - osób, które na co dzień pracują z tym, czego uczą, i znają realia branży.'
}, {
  lead: 'Platforma AlgoAcademy',
  rest: 'Otrzymujesz dostęp do centrum treningowego, w którym zapisujesz się na kursy, rozwiązujesz zadania i krok po kroku realizujesz swój plan.'
}, {
  lead: 'Widoczne postępy',
  rest: 'Śledzisz swój progres na bieżąco, dzięki czemu skupiasz się tylko na tym, co ważne. Nie tracisz czasu na domysły, czy coś przypadkiem Ci nie umknęło.'
}, {
  lead: 'Wsparcie asystenta AI',
  rest: 'W ramach aplikacji zyskujesz osobistego asystenta AI, który wspiera Cię 24/7. Jest zintegrowany z całą platformą i został zaprojektowany specjalnie pod samodzielną naukę.'
}, {
  lead: 'Ambitna społeczność',
  rest: 'Nie uczysz się w pojedynkę - otaczasz się ambitnymi ludźmi z podobnymi celami. Wymieniacie się doświadczeniami, uczycie się razem, a zdrowa rywalizacja podkręca tempo.'
}, {
  lead: 'Materiały i baza wiedzy',
  rest: 'Dostajesz kompletne, uporządkowane materiały - stworzone lub zweryfikowane przez naszych mentorów.'
}, {
  lead: 'Gwarancja zwrotu pieniędzy',
  rest: <>
        Jeśli po 3 miesiącach współpracy nie spełnimy Twoich oczekiwań, zwracamy Ci 100% kosztów -
        szczegóły w{' '}
        <Link href={regulaminSectionHref('complaints')} className='font-semibold text-algoprimary underline'>
          regulaminie
        </Link>
        .
      </>
}];
export function GroupMentoringOptions() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ul className="space-y-4">{BENEFITS.map(_temp)}</ul>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(t0) {
  const {
    lead,
    rest
  } = t0;
  return <li key={lead}><IconOnTheLeftWithContentLayout mainContent={<P2 className="text-contentSecondary"><strong className="block font-semibold text-contentPrimary">{lead}</strong>{rest}</P2>} /></li>;
}